import React from 'react';
import { CheckIcon, LockIcon } from 'lucide-react';
export function Checkout() {
  const features = ['10 Módulos completos en PDF', '9 Bonos exclusivos (gratis hoy)', 'Plantillas editables listas para usar', 'Casos prácticos resueltos', 'Acceso inmediato y para siempre'];
  return <section id="compra" className="w-full max-w-4xl mx-auto px-4 py-12" data-id="element-38" data-mp="3ep4wrqorw8lq">
      <div className="bg-gradient-to-br from-emerald-50 to-teal-50 border-2 border-emerald-200 rounded-2xl p-8 md:p-12 shadow-xl" data-id="element-39" data-mp="39oz2s3v16a0h">
        <div className="text-center mb-8" data-id="element-40" data-mp="34p48dqc1r2ao">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-41" data-mp="34sidv7g0brmc">
            Conseguí tu Kit RRHH en Orden ahora
          </h2>
          <p className="text-lg text-gray-700" data-id="element-42" data-mp="2vq95an4au8bl">
            Todo lo que necesitás para gestionar RRHH sin errores ni riesgos
          </p>
        </div>

        <div className="bg-white rounded-xl p-6 mb-8 shadow-sm" data-id="element-43" data-mp="xxll6bpp8k97">
          <ul className="space-y-3" data-id="element-44" data-mp="tzfknlfgf0wq">
            {features.map((feature, index) => <li key={index} className="flex items-center gap-3" data-id="element-45" data-mp="2eb8b95nq1wvg" data-mpi={index}>
                <CheckIcon className="w-5 h-5 text-emerald-500 flex-shrink-0" data-id="element-46" data-mp="2jb33bcj8gsi3" />
                <span className="text-gray-700" data-id="element-47" data-mp="2j903k0sa3l06">{feature}</span>
              </li>)}
          </ul>
        </div>

        <div className="text-center mb-8" data-id="element-48" data-mp="29cx08rloxgbn">
          <div className="mb-4" data-id="element-49" data-mp="29doy692rfq53">
            <span className="text-gray-500 line-through text-2xl" data-id="element-50" data-mp="29f00e4gk4pu3">$54.990</span>
          </div>
          <div className="text-5xl md:text-6xl font-bold text-gray-900 mb-2" data-id="element-51" data-mp="2x53thhw4d76u">
            $21.999
          </div>
          <p className="text-sm text-gray-600" data-id="element-52" data-mp="2oafrq1pr67ms">
            Precio especial por tiempo limitado
          </p>
        </div>

        <a href="https://rrhhenorden.ebookdreamshop.shop/o/rrhh-para-pymes" className="block w-full bg-gradient-to-r from-emerald-500 to-teal-500 text-white text-center px-10 py-5 rounded-full text-xl font-bold hover:shadow-2xl hover:scale-105 transition-all duration-300 mb-4" data-id="element-53" data-mp="2sb9dopjmxcd1">
          Quiero mi pack RRHH ahora
        </a>

        <div className="flex items-center justify-center gap-2 text-sm text-gray-600" data-id="element-54" data-mp="3ulzq0ci3ls4n">
          <LockIcon className="w-4 h-4" data-id="element-55" data-mp="3qkmilxzcxgvm" />
          <span data-id="element-56" data-mp="3ln4i8vzeo9z8">Pago seguro • Entrega inmediata por email</span>
        </div>
      </div>
    </section>;
}